import { chartLabels, platformIcons, TABLE_COLUMN_TYPE } from "../../../../constants"
import { SummaryUpcoming, TableColumn } from "../../../../types"
import { KSpan } from "kahuna-base-react-components"
import { lang } from "../../../../constants/languages"
import React from "react"
import { formatNumber, getCurrency } from "../../../../utility"

const upcomingColumns: TableColumn[] = [
  {
    header: lang.royalties.upcoming.columns.dsp,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "24%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.upcoming.columns.dsp} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryUpcoming) => {
      return (
        <div className="flex gap-1">
          <img width={24} src={platformIcons[row.dsp]} />
          <KSpan text={chartLabels.platform[row.dsp]} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.upcoming.columns.activityPeriod,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "18%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.upcoming.columns.activityPeriod} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryUpcoming) => {
      return (
        <div>
          <KSpan text={row.activityPeriod} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.upcoming.columns.reportingPeriod,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "18%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.upcoming.columns.reportingPeriod} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryUpcoming) => {
      return (
        <div>
          <KSpan text={row.reportingPeriod} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.upcoming.columns.quantity,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "20%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.upcoming.columns.quantity} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryUpcoming) => {
      return (
        <div>
          <KSpan text={row.quantity.toLocaleString()} />
        </div>
      )
    }
  },
  {
    header: lang.royalties.upcoming.columns.totalNet,
    headerStyle: {
      textAlign: "left",
      minWidth: "120px",
      width: "20%"
    },
    overrideHeader: () => (
      <KSpan text={lang.royalties.upcoming.columns.totalNet} color="#111" fontWeight={500} fontSize={14} />
    ),
    type: TABLE_COLUMN_TYPE.FUNCTION,
    render: (row: SummaryUpcoming) => {
      const totalNet = row.totalNet.toLocaleString("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      const currency = getCurrency(row.currency)
      return (
        <div>
          <KSpan text={`${totalNet} ${currency}`} />
        </div>
      )
    }
  }
]

export default upcomingColumns
